import { call, put, takeLatest } from "redux-saga/effects"

import ErrorsActions from "../../Redux/ErrorsRedux"
import { apiGeneratorBase } from "../../Utils/saga"
import * as baServices from "../BusinessAccountsPage/services"
import * as userServices from "../User/services"
import Creators, { ReferralTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  inviteByEmailActions: {
    request: Creators.inviteByEmailRequest,
    success: Creators.inviteByEmailSuccess,
    errors: Creators.inviteByEmailFailure
  },
  getYourCommissionsActions: {
    request: Creators.getYourCommissionsRequest,
    success: Creators.getYourCommissionsSuccess,
    errors: Creators.getYourCommissionsFailure
  },
  getInviteLinkActions: {
    request: Creators.getInviteLinkRequest,
    success: Creators.getInviteLinkSuccess,
    errors: Creators.getInviteLinkFailure
  },
  getReferralsTableActions: {
    request: Creators.getReferralsTableRequest,
    success: Creators.getReferralsTableSuccess,
    errors: Creators.getReferralsTableFailure
  },
  getAlertsByBusinessAccountIdActions: {
    request: Creators.getAlertsByBusinessAccountIdRequest,
    success: Creators.getAlertsByBusinessAccountIdSuccess,
    errors: Creators.getAlertsByBusinessAccountIdFailure
  },
  getFaqActions: {
    request: Creators.getFaqRequest,
    success: Creators.getFaqSuccess,
    errors: Creators.getFaqFailure
  },
  getTotalStatisticsActions: {
    request: Creators.getTotalStatisticsRequest,
    success: Creators.getTotalStatisticsSuccess,
    errors: Creators.getTotalStatisticsFailure
  },
  getReferralsOverviewDataActions: {
    request: Creators.getReferralsOverviewDataRequest,
    success: Creators.getReferralsOverviewDataSuccess,
    errors: Creators.getReferralsOverviewDataFailure
  },
  getReferralsOverviewMainInfoActions: {
    request: Creators.getReferralsOverviewMainInfoRequest,
    success: Creators.getReferralsOverviewMainInfoSuccess,
    errors: Creators.getReferralsOverviewMainInfoFailure
  },
  getReferralBAOptionsActions: {
    request: Creators.getReferralBAOptionsRequest,
    success: Creators.getReferralBAOptionsSuccess,
    errors: Creators.getReferralBAOptionsFailure
  },
  getAlertsBySourceTableActions: {
    request: Creators.getAlertsBySourceTableRequest,
    success: Creators.getAlertsBySourceTableSuccess,
    errors: Creators.getAlertsBySourceTableFailure
  },
  getAdminStatisticBlocksActions: {
    request: Creators.getAdminStatisticBlocksRequest,
    success: Creators.getAdminStatisticBlocksSuccess,
    errors: Creators.getAdminStatisticBlocksFailure
  },
  getAdminStatisticBlockChartActions: {
    request: Creators.getAdminStatisticBlockChartRequest,
    success: Creators.getAdminStatisticBlockChartSuccess,
    errors: Creators.getAdminStatisticBlockChartFailure
  },
  getAdminTableActions: {
    request: Creators.getAdminTableRequest,
    success: Creators.getAdminTableSuccess,
    errors: Creators.getAdminTableFailure
  },
  exportAdminTableActions: {
    request: Creators.exportAdminTableRequest,
    success: Creators.exportAdminTableSuccess,
    errors: Creators.exportAdminTableFailure
  },
  getAdminTableAlertsChartActions: {
    request: Creators.getAdminTableAlertsChartRequest,
    success: Creators.getAdminTableAlertsChartSuccess,
    errors: Creators.getAdminTableAlertsChartFailure
  },
  getAdminTableRewardChartActions: {
    request: Creators.getAdminTableRewardChartRequest,
    success: Creators.getAdminTableRewardChartSuccess,
    errors: Creators.getAdminTableRewardChartFailure
  },
  getOutsiderBlocksActions: {
    request: Creators.getOutsiderBlocksRequest,
    success: Creators.getOutsiderBlocksSuccess,
    errors: Creators.getOutsiderBlocksFailure
  },
  outsiderWithdrawActions: {
    request: Creators.outsiderWithdrawRequest,
    success: Creators.outsiderWithdrawSuccess,
    errors: Creators.outsiderWithdrawFailure,
    extraAction: [() => Creators.getOutsiderBlocksRequest()]
  },
  getOutsiderPayoutMethodActions: {
    request: Creators.getOutsiderPayoutMethodRequest,
    success: Creators.getOutsiderPayoutMethodSuccess,
    errors: Creators.getOutsiderPayoutMethodFailure
  },
  addOutsiderPayoutMethodActions: {
    request: Creators.addOutsiderPayoutMethodRequest,
    success: Creators.addOutsiderPayoutMethodSuccess,
    errors: Creators.addOutsiderPayoutMethodFailure,
    extraAction: [
      () => Creators.getOutsiderBlocksRequest(),
      () => Creators.getOutsiderPayoutMethodRequest()
    ]
  },
  updateOutsiderPayoutMethodActions: {
    request: Creators.updateOutsiderPayoutMethodRequest,
    success: Creators.updateOutsiderPayoutMethodSuccess,
    errors: Creators.updateOutsiderPayoutMethodFailure,
    extraAction: [
      () => Creators.getOutsiderBlocksRequest(),
      () => Creators.getOutsiderPayoutMethodRequest()
    ]
  },
  getOutsiderWithdrawalsHistoryActions: {
    request: Creators.getOutsiderWithdrawalsHistoryRequest,
    success: Creators.getOutsiderWithdrawalsHistorySuccess,
    errors: Creators.getOutsiderWithdrawalsHistoryFailure
  },
  getReferralBusinessAccountInfoActions: {
    request: Creators.getReferralBusinessAccountInfoRequest,
    success: Creators.getReferralBusinessAccountInfoSuccess,
    errors: Creators.getReferralBusinessAccountInfoFailure
  },
  getAffiliateAccountInfoActions: {
    request: Creators.getAffiliateAccountInfoRequest,
    success: Creators.getAffiliateAccountInfoSuccess,
    errors: Creators.getAffiliateAccountInfoFailure
  },
  getCountryCodesActions: {
    request: Creators.getCountryCodesRequest,
    success: Creators.getCountryCodesSuccess,
    errors: Creators.getCountryCodesFailure
  }
}

const referralsOptions = {
  [constants.INVITE_BY_EMAIL_REQUEST]: {
    api: services.inviteByEmail,
    actions: actions.inviteByEmailActions
  },
  [constants.GET_YOUR_COMMISSIONS_REQUEST]: {
    api: services.getYourCommissions,
    actions: actions.getYourCommissionsActions
  },
  [constants.GET_INVITE_LINK_REQUEST]: {
    api: services.getInviteLink,
    actions: actions.getInviteLinkActions
  },
  [constants.GET_REFERRALS_TABLE_REQUEST]: {
    api: services.referralsTable,
    actions: actions.getReferralsTableActions
  },
  [constants.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_REQUEST]: {
    api: baServices.getAlertsChart,
    actions: actions.getAlertsByBusinessAccountIdActions
  },
  [constants.GET_FAQ_REQUEST]: {
    api: services.getFaq,
    actions: actions.getFaqActions
  },
  [constants.GET_TOTAL_STATISTICS_REQUEST]: {
    api: services.getTotalStatistics,
    actions: actions.getTotalStatisticsActions
  },
  [constants.GET_REFERRALS_OVERVIEW_DATA_REQUEST]: {
    api: services.getReferralsOverviewData,
    actions: actions.getReferralsOverviewDataActions
  },
  [constants.GET_REFERRALS_OVERVIEW_MAIN_INFO_REQUEST]: {
    api: services.getReferralsOverviewMainInfo,
    actions: actions.getReferralsOverviewMainInfoActions
  },
  [constants.GET_REFERRAL_BA_OPTIONS_REQUEST]: {
    api: services.getReferralBAOptions,
    actions: actions.getReferralBAOptionsActions
  },
  [constants.GET_ALERTS_BY_SOURCE_TABLE_REQUEST]: {
    api: services.getAlertsBySourceTable,
    actions: actions.getAlertsBySourceTableActions
  },
  [constants.GET_ADMIN_STATISTIC_BLOCKS_REQUEST]: {
    api: services.getAdminStatisticBlocks,
    actions: actions.getAdminStatisticBlocksActions
  },
  [constants.GET_ADMIN_STATISTIC_BLOCK_CHART_REQUEST]: {
    api: services.getAdminStatisticBlockChart,
    actions: actions.getAdminStatisticBlockChartActions
  },
  [constants.GET_ADMIN_TABLE_REQUEST]: {
    api: services.getAdminTable,
    actions: actions.getAdminTableActions
  },
  [constants.EXPORT_ADMIN_TABLE_REQUEST]: {
    api: services.exportAdminTable,
    actions: actions.exportAdminTableActions
  },
  [constants.GET_ADMIN_TABLE_ALERTS_CHART_REQUEST]: {
    api: services.getAdminTableAlertsChart,
    actions: actions.getAdminTableAlertsChartActions
  },
  [constants.GET_ADMIN_TABLE_REWARD_CHART_REQUEST]: {
    api: services.getAdminTableRewardChart,
    actions: actions.getAdminTableRewardChartActions
  },
  [constants.GET_OUTSIDER_BLOCKS_REQUEST]: {
    api: services.getOutsiderBlocks,
    actions: actions.getOutsiderBlocksActions
  },
  [constants.OUTSIDER_WITHDRAW_REQUEST]: {
    api: services.outsiderWithdraw,
    actions: actions.outsiderWithdrawActions
  },
  [constants.GET_OUTSIDER_PAYOUT_METHOD_REQUEST]: {
    api: services.getOutsiderPayoutMethod,
    actions: actions.getOutsiderPayoutMethodActions
  },
  [constants.ADD_OUTSIDER_PAYOUT_METHOD_REQUEST]: {
    api: services.addOutsiderPayoutMethod,
    actions: actions.addOutsiderPayoutMethodActions
  },
  [constants.UPDATE_OUTSIDER_PAYOUT_METHOD_REQUEST]: {
    api: services.updateOutsiderPayoutMethod,
    actions: actions.updateOutsiderPayoutMethodActions
  },
  [constants.GET_OUTSIDER_WITHDRAWALS_HISTORY_REQUEST]: {
    api: services.getOutsiderWithdrawalsHistory,
    actions: actions.getOutsiderWithdrawalsHistoryActions
  },
  [constants.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_REQUEST]: {
    api: services.getReferralBusinessAccountInfo,
    actions: actions.getReferralBusinessAccountInfoActions
  },
  [constants.GET_AFFILIATE_ACCOUNT_INFO_REQUEST]: {
    api: userServices.getUserInfo,
    actions: actions.getAffiliateAccountInfoActions
  },
  [constants.GET_COUNTRY_CODES_REQUEST]: {
    api: services.countryCodes,
    actions: actions.getCountryCodesActions
  }
}

function* inviteByEmailSaga(action) {
  const { data, onSuccess, onError } = action.payload
  const response = yield call(services.inviteByEmail, data)
  if (response.ok) {
    yield put(Creators.inviteByEmailSuccess(response.data))
    onSuccess?.(response?.data)
  } else {
    yield put(Creators.inviteByEmailFailure())
    let error = response.data
    onError?.(error)
    yield put(ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error))
  }
}

function* addOutsiderPayoutMethodSaga(action) {
  const { payload } = action
  const { data, onSuccess, onError } = payload
  const response = yield call(services.addOutsiderPayoutMethod, data)
  if (response.ok) {
    yield put(Creators.addOutsiderPayoutMethodSuccess(response.data))
    yield put(Creators.getOutsiderBlocksRequest())
    yield put(Creators.getOutsiderPayoutMethodRequest())
    onSuccess?.()
  } else {
    yield put(Creators.addOutsiderPayoutMethodFailure())
    onError?.(response.data)
  }
}

function* updateOutsiderPayoutMethodSaga(action) {
  const { payload } = action
  const { data, onSuccess, onError } = payload
  const response = yield call(services.updateOutsiderPayoutMethod, data)
  if (response.ok) {
    yield put(Creators.updateOutsiderPayoutMethodSuccess(response.data))
    yield put(Creators.getOutsiderBlocksRequest())
    yield put(Creators.getOutsiderPayoutMethodRequest())
    onSuccess?.()
  } else {
    yield put(Creators.updateOutsiderPayoutMethodFailure())
    onError?.(response.data)
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.INVITE_BY_EMAIL_REQUEST, (action) => inviteByEmailSaga(action))
  yield takeLatest(constants.GET_YOUR_COMMISSIONS_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_YOUR_COMMISSIONS_REQUEST])
  )
  yield takeLatest(constants.GET_INVITE_LINK_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_INVITE_LINK_REQUEST])
  )
  yield takeLatest(constants.GET_REFERRALS_TABLE_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_REFERRALS_TABLE_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_REQUEST])
  )
  yield takeLatest(constants.GET_FAQ_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_FAQ_REQUEST])
  )
  yield takeLatest(constants.GET_TOTAL_STATISTICS_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_TOTAL_STATISTICS_REQUEST])
  )
  yield takeLatest(constants.GET_REFERRALS_OVERVIEW_DATA_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_REFERRALS_OVERVIEW_DATA_REQUEST])
  )
  yield takeLatest(constants.GET_REFERRALS_OVERVIEW_MAIN_INFO_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_REFERRALS_OVERVIEW_MAIN_INFO_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_BY_SOURCE_TABLE_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ALERTS_BY_SOURCE_TABLE_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_STATISTIC_BLOCKS_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ADMIN_STATISTIC_BLOCKS_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_STATISTIC_BLOCK_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ADMIN_STATISTIC_BLOCK_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_TABLE_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ADMIN_TABLE_REQUEST])
  )
  yield takeLatest(constants.EXPORT_ADMIN_TABLE_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.EXPORT_ADMIN_TABLE_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_TABLE_ALERTS_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ADMIN_TABLE_ALERTS_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_TABLE_REWARD_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_ADMIN_TABLE_REWARD_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_REFERRAL_BA_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_REFERRAL_BA_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_OUTSIDER_BLOCKS_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_OUTSIDER_BLOCKS_REQUEST])
  )
  yield takeLatest(constants.OUTSIDER_WITHDRAW_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.OUTSIDER_WITHDRAW_REQUEST])
  )

  yield takeLatest(constants.GET_OUTSIDER_PAYOUT_METHOD_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_OUTSIDER_PAYOUT_METHOD_REQUEST])
  )
  yield takeLatest(constants.ADD_OUTSIDER_PAYOUT_METHOD_REQUEST, (action) =>
    addOutsiderPayoutMethodSaga(action)
  )
  yield takeLatest(constants.UPDATE_OUTSIDER_PAYOUT_METHOD_REQUEST, (action) =>
    updateOutsiderPayoutMethodSaga(action)
  )
  yield takeLatest(constants.GET_OUTSIDER_WITHDRAWALS_HISTORY_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_OUTSIDER_WITHDRAWALS_HISTORY_REQUEST])
  )
  yield takeLatest(constants.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_REQUEST])
  )
  yield takeLatest(constants.GET_AFFILIATE_ACCOUNT_INFO_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_AFFILIATE_ACCOUNT_INFO_REQUEST])
  )
  yield takeLatest(constants.GET_COUNTRY_CODES_REQUEST, (action) =>
    apiGeneratorBase(action, referralsOptions[constants.GET_COUNTRY_CODES_REQUEST])
  )
}
